import { render, staticRenderFns } from "./BlogHandpick.vue?vue&type=template&id=dfec8d82&scoped=true"
import script from "./BlogHandpick.vue?vue&type=script&lang=js"
export * from "./BlogHandpick.vue?vue&type=script&lang=js"
import style0 from "./BlogHandpick.vue?vue&type=style&index=0&id=dfec8d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfec8d82",
  null
  
)

export default component.exports